/* jshint esversion: 8 */
import { toJS } from "mobx";
import ComfortableHousingRequestHandler from '../../../db/ComfortableHousingRequestHandler';
import store from "../../../components/stores/Store";
import LocalStore from "./LocalStore";
import { exportExcel as exportExcelUtil } from "../../../utils/ExcelHandler";
import { tableFieldsConfig } from './data';

import FormData from "form-data";

const search = async function () {
  await getRecord();
};
const getRecord = async function () {
  const wheres = {};
  // propertyName: ["like", store.selections.propertyName],
  const selectionKeys = Object.keys(store.selections);
  for (let index = 0; index < selectionKeys.length; index++) {
    const sid = selectionKeys[index];
    const value = store.selections[sid];

    let searchType = 'EQUAL';
    for (let index = 0; index < LocalStore.tableFields.length; index++) {
      const tableField = LocalStore.tableFields[index];
      if (sid === tableField.sid) {
        searchType = tableField.searchType;
        break;
      }
    }
    wheres[sid] = [searchType, value];
  }

  console.log(`----- wheres: `, wheres);

  const rst = await ComfortableHousingRequestHandler.getRecord({
    where: wheres,
    order: store.tableConfig.order || 'desc',
    orderBy: store.tableConfig.orderBy || 'id',
    currentPage: store.tableConfig.currentPage || 0, // 当前页
    rowsPerPage: store.tableConfig.rowsPerPage || 10, // 每页条数
  });

  if (rst.code === "error") {
    store.openMessageDialogOpen(rst.msg || "查询错误");
  } else if (rst.code === "success") {
    store.setTable(rst.data);
    store.setTableCount(rst.count || 0);
  }
};

const addRecord = async function (data) {
  const rst = await ComfortableHousingRequestHandler.addRecord(data);
  return rst;
};


const updateRecord = async function () {
  const oldInfo = LocalStore.updateRecordOldInfo;
  const newInfo = LocalStore.updateRecordInfo;

  const keys = Object.keys(oldInfo);
  const updateData = {};

  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];
    console.log(`----- newInfo[key]: `, newInfo[key]);
    console.log(`----- oldInfo[key]: `, oldInfo[key]);
    if (oldInfo[key] !== newInfo[key]) {
      updateData[key] = newInfo[key];
    }
  }

  console.log(`----- updateData: `, updateData);

  if (Object.keys(updateData).length === 0) {
    store.openMessageDialogOpen("无需更新");
    return;
  }

  const rst = await ComfortableHousingRequestHandler.updateRecord({
    id: oldInfo.id,
    updateData: updateData,
  });

  if (rst.code === "error") {
    store.openMessageDialogOpen(rst.msg || "更新失败");
  } else if (rst.code === "success") {
    store.openMessageDialogOpen(rst.msg || '更新成功');
    LocalStore.switchUpdateDialog();
    store.search();
  }
  return null;
};

const deleteRecord = async function (ids) {
  const rst = await ComfortableHousingRequestHandler.deleteRecord({ ids });
  return rst;
};

const deleteRecords = async function () {
  const ids = toJS(store.linesSelected);
  console.log(`----- deleteRecords-ids: `, ids);
  const rst = await ComfortableHousingRequestHandler.deleteRecord({ ids });
  if (rst.code === "error") {
    store.openMessageDialogOpen(rst.msg || "系统错误");
  } else if (rst.code === "success") {
    store.openMessageDialogOpen(rst.msg || "删除成功");
    store.search();
  }
};


const exportTemplateExcel = async function () {
  const xlsxName = "安置房住户明细表模板20230807";

  const xlsxHeader = {};
  for (let index = 1; index < tableFieldsConfig.length; index++) {
    const element = tableFieldsConfig[index];
    xlsxHeader[element.sid] = element.label;
  }

  const file = exportExcelUtil([], xlsxHeader, xlsxName);
  return file;
};


const importExcel = async function (data) {
  const rst = await ComfortableHousingRequestHandler.importExcel(data);
  return rst;
}


function reader(file, options) {
  options = options || {};
  return new Promise(function (resolve, reject) {
    let reader = new FileReader();

    reader.onload = function () {
      resolve(reader);
    };
    reader.onerror = reject;

    if (options.accept && !new RegExp(options.accept).test(file.type)) {
      reject({
        code: 1,
        msg: 'wrong file type'
      });
    }

    reader.readAsBinaryString(file);
  });
}


const exportExcel = async function () {
  const wheres = {};
  const selectionKeys = Object.keys(store.selections);
  for (let index = 0; index < selectionKeys.length; index++) {
    const sid = selectionKeys[index];
    const value = store.selections[sid];

    let searchType = 'EQUAL';
    for (let index = 0; index < LocalStore.tableFields.length; index++) {
      const tableField = LocalStore.tableFields[index];
      if (sid === tableField.sid) {
        searchType = tableField.searchType;
        break;
      }
    }
    wheres[sid] = [searchType, value];
  }

  console.log(`----- wheres: `, wheres);

  const rst = await ComfortableHousingRequestHandler.exportExcel({
    where: wheres,
    order: store.tableConfig.order || 'desc',
    orderBy: store.tableConfig.orderBy || 'id',
    currentPage: store.tableConfig.currentPage || 0, // 当前页
    rowsPerPage: store.tableConfig.rowsPerPage || 10, // 每页条数
  });
  return rst;
};


const uploadFile = async function (e) {
  console.log(`----- importExcel3-e.target.files: `, e.target.files);
  const file = Array.from(e.target.files)[0];
  const formData = new FormData();
  formData.append("file", file);
  formData.append("marketId", store.marketId);
  formData.append("createBy", store.user.uuid);
  const authorization = toJS(store.user.JWTToken);
  formData.append("authorization", authorization);
  const rst = await ComfortableHousingRequestHandler.uploadExcel(formData);
  return rst;
}

export default {
  search,
  addRecord,
  updateRecord,
  deleteRecord,
  deleteRecords,
  exportTemplateExcel,
  exportExcel,
  importExcel,
  uploadFile,
};
